window._ = require("lodash");
window.lightSlider = require("lightslider");
require("bootstrap");

// Import Google maps functionality
import "./maps";

// Import flickity and jQuery bridge
require("flickity-imagesloaded");
require("flickity-fullscreen");
import flickity from "flickity";
import jQueryBridget from "jquery-bridget";

// Sets variable screen width used for responsive javascripts
var window_width = Math.min(window.innerWidth || Infinity, screen.width);
var activePrincipalsTab = 0;

// window.Vue = require('vue');
// import yourname from '';

// new Vue({
//     el: '#element',
//     components: { yourname }

jQuery(document).ready(function($) {
    //Flickity init
    jQueryBridget("flickity", flickity, $);

    // Slider - topbanner
    var carouselSettings = {
        freeScroll: false,
        autoPlay: 3000,
        fullscreen: false,
        cellAlign: "left"
    };
    slider(".flickity-carousel", carouselSettings, "slider-top");

    // Slider - bred banner som bläddrar
    var carouselSettingsWideScroll = {
        freeScroll: false,
        fullscreen: false,
        pageDots: false,
        cellAlign: "left"
    };
    slider(
        ".flickity-carousel-widescroll",
        carouselSettingsWideScroll,
        "slider-wide"
    );

    if ($(".startBanner").length > 0) {
        $(".startBanner").addClass("visible");
    }

    $("body").removeClass("preload");

    $(".mobile-nav-menu-button").click(function() {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(".nav-menu").removeClass("active");
            $(".mobile-nav-menu-fader").removeClass("active");
            $("body").removeClass("hidescroll");
        } else {
            $(this).addClass("active");
            $(".nav-menu").addClass("active");
            $(".mobile-nav-menu-fader").addClass("active");
            $("body").addClass("hidescroll");
        }
    });

    $(".mobile-nav-menu-fader").click(function() {
        if ($(".mobile-nav-menu-fader").hasClass("active")) {
            $(".mobile-nav-menu-button").removeClass("active");
            $(".nav-menu").removeClass("active");
            $(".mobile-nav-menu-fader").removeClass("active");
            $("body").removeClass("hidescroll");
        }
    });

    // $(".nav-arrow").click(function() {
    //     var objektet = $(this)
    //         .parent()
    //         .parent();

    //     if (objektet.hasClass("folded")) {
    //         objektet.removeClass("folded");
    //     } else {
    //         objektet.addClass("folded");
    //     }
    // });

    $(".nav-arrow").click(function() {

        var currentitem = $(this).closest('.nav-menu-item');
        
        if (currentitem.hasClass("folded")) {
            currentitem.removeClass("folded");
        } else {
            $(".nav-menu-item").removeClass("folded");
            currentitem.addClass("folded");
        }
    });

    $(".news-category-title").click(function() {

        if ($(this).hasClass("folded")) {
            $(this).removeClass("folded");
            $(".news-categories").removeClass("folded");
            
        } else {
            $(".news-categories").addClass("folded");
            $(this).addClass("folded");
        }
    });

    /* Click function on scroll top button */
    jQuery(".scrollToTop").click(function() {
        jQuery("html, body").animate(
            {
                scrollTop: 0
            },
            300
        );
    });

    /* Show desktop search */
    jQuery("#search-icon").click(function() {
        if (jQuery(".search-overlay").hasClass("active")) {
            jQuery(".search-overlay").removeClass("active");
        } else {
            $(".nav-menu-item").removeClass("folded");
            jQuery(".search-overlay").addClass("active");
            setTimeout(function() {
                $("#search-desktop").focus();
            }, 251);
        }
    });

    function scrollToTab(object,speed,desktop)
    {
        var scrolltop = object.offset().top;

        if(desktop == true)
        {
            scrolltop = scrolltop-84;
        }

        jQuery("html, body").animate(
            {
                scrollTop: scrolltop
            },
            speed
        );
    }
    

    /* FAQ tabs */
    jQuery(".faq-tab").click(function() {
            
        var clickedtab = jQuery(this);

        if (clickedtab.hasClass("folded")) {
            clickedtab.removeClass("folded");
            clickedtab
                .find(".body")
                .slideUp();
        } else {
            clickedtab.addClass("folded");
            clickedtab
                .find(".body")
                .slideDown();

            if(window_width <= 576){
                scrollToTab(clickedtab,500,false);
            }
        }
    });


    /* Principal tabs - function and event */

    function principalsTab(tab,canclose)
    {
        var clickedtab = tab.parent();

        var clickedtabId = clickedtab.attr("id");
        var clickedtabIdArray = clickedtabId.split("_");
        var clickedtabIdNum = clickedtabIdArray[1];

        if (clickedtab.hasClass("folded") && canclose == true) {
            
            clickedtab.removeClass("folded");
            clickedtab
                .find(".body")
                .slideUp();

            activePrincipalsTab = 0;
            jQuery(".principal-menu").removeClass("show");            

        } else {
            
            // jQuery(".principal").removeClass("folded");
            // jQuery(".principal")
            //     .find(".body")
            //     .slideUp(function(){
                    
            //         if(window_width <= 576){
            //             scrollToTab(clickedtab,250,false);
            //         }else{
            //             scrollToTab(clickedtab,250,true);
            //         }
                    
            //     });

            clickedtab.addClass("folded");
            clickedtab
                .find(".body")
                .slideDown();

            if(window_width <= 576){
                scrollToTab(clickedtab,250,false);
            }else{
                scrollToTab(clickedtab,250,true);
            }

            /* Principals menu */
            activePrincipalsTab = clickedtabIdNum;
            jQuery(".principal-menu").addClass("show");
            jQuery(".principal-title").removeClass("active");
            jQuery("#principaltitle_"+clickedtabIdNum).addClass("active");
            
            if(clickedtabIdNum == 1){
                jQuery("#previousPrincipal").addClass("disabled");
            }else{
                jQuery("#previousPrincipal").removeClass("disabled");
            }

            if(clickedtabIdNum == totalPrincipals){
                jQuery("#nextPrincipal").addClass("disabled");
            }else{
                jQuery("#nextPrincipal").removeClass("disabled");
            }

        }
    }

    
    jQuery("#nextPrincipal").click(function() {
        
        if( !jQuery(this).hasClass('disabled') )
        {
            var next = parseInt(activePrincipalsTab) + 1;
            next = next.toString();
            principalsTab(jQuery("#principal_"+next).find(".principal-head"),false);
        }

    });

    jQuery("#previousPrincipal").click(function() {
        
        if( !jQuery(this).hasClass('disabled') )
        {
            var previous = parseInt(activePrincipalsTab) - 1;
            previous = previous.toString();
            principalsTab(jQuery("#principal_"+previous).find(".principal-head"),false);
        }
    });

    jQuery(".principal-head").click(function() {

        principalsTab(jQuery(this),true);
        
    });


});

jQuery(window).scroll(function() {
    scrollTopArrow(200);
    menuShadow(100);
});

/* Shows or hide the button that scrolls to top */
function scrollTopArrow(scrollpos) {
    if (jQuery(window).scrollTop() > scrollpos) {
        if (!jQuery(".courseButton").is(":visible")) {
            jQuery(".scrollToTop").addClass("active");
        }
    }

    if (jQuery(window).scrollTop() < scrollpos) {
        jQuery(".scrollToTop").removeClass("active");
    }
}

/* Shor or hide shadow of header depending on scroll position */
function menuShadow(scrollpos) {
    if (jQuery(window).scrollTop() > scrollpos) {
        if (!jQuery(".header").hasClass("sticky")) {
            jQuery(".header").addClass("sticky");
        }
    }

    if (jQuery(window).scrollTop() < scrollpos) {
        jQuery(".header").removeClass("sticky");
    }
}

function slider(element, settings, name) {
    var instance = jQuery(element).flickity(settings);
    /*
    jQuery("body").on("mouseenter", ".flickity-carousel", function(event) {
        var index = jQuery(event.currentTarget).index();
        console.log(index);

        console.log(jQuery(this));

        jQuery(this)
            .closest(".flickity-button")
            .show();
        // jQuery(".flickity-page-dots").show();
        // jQuery(".flickity-button").show();
    });

    jQuery("body").on("mouseleave", ".flickity-carousel", function(event) {
        var index = jQuery(event.currentTarget).index();
        console.log(index);

        // jQuery(".flickity-page-dots").hide();
        // jQuery(".flickity-button").hide();
    });*/

    if (instance.length) {
        var flkty = instance.data("flickity");
        var classes = flkty.element.classList;

        if (flkty.cells.length <= 1) {
            jQuery(".flickity-page-dots").hide();
            jQuery(".flickity-button").hide();
        }
    }
}



// WEBPACK FOOTER //
// ./assets/js/app.js